import { useContext } from "react";
import "./progressbar.css";
import { Link } from "react-router-dom";
import PortalContext from "../../Pages/PortalContext";

export default function ProgressBar(props) {
  const { portal } = useContext(PortalContext);

  //get the current page that you're on
  const currentPage = window.location.pathname.split("/").pop();

  return (
    <>
      <div class="progress-breadcrumb">
        <div className="">
          <Link
            to="/"
            style={{ backgroundColor: portal.data.settings.colours.primary }}
          >
            <span>
              <i className="fa fa-check"></i>
              <ins style={{ color: "white" }}>1</ins>
            </span>
          </Link>
        </div>

        <div class="">
          <Link
            to={`/step-2`}
            style={{
              backgroundColor: `${portal.data.settings.colours.primary}`,
            }}
          >
            <span>
              <i class="fa fa-check"></i>
              <ins style={{ color: "white" }}>2</ins>
            </span>
          </Link>
        </div>

        <div
          class={"btn-group pull-right " + (props.step === 2 ? "white" : "")}
        >
          {currentPage === "step-2" ? (
            <Link
              to={`/step-2`}
              style={{ borderColor: `${portal.data.settings.colours.primary}` }}
            >
              <span>
                <i class="fa fa-check"></i>
                <ins
                  style={{ color: `${portal.data.settings.colours.primary}` }}
                >
                  3
                </ins>
              </span>
            </Link>
          ) : !portal?.step3manual ? (
            <Link
              to={`/step-3`}
              style={{
                backgroundColor: `${portal.data.settings.colours.primary}`,
              }}
            >
              <span>
                <i class="fa fa-check"></i>
                <ins style={{ color: "white" }}>3</ins>
              </span>
            </Link>
          ) : (
            <Link
              to={`/step-3-manual`}
              style={{
                backgroundColor: `${portal.data.settings.colours.primary}`,
              }}
            >
              <span>
                <i class="fa fa-check"></i>
                <ins style={{ color: "white" }}>3</ins>
              </span>
            </Link>
          )}
        </div>

        <div
          class={
            "btn-group pull-right " +
            (props.step === 2 || props.step === 3 ? "white" : "")
          }
        >
          {currentPage === "step-2" ? (
            <Link
              to={`/step-2`}
              style={{ borderColor: `${portal.data.settings.colours.primary}` }}
            >
              <span>
                <i class="fa fa-check"></i>
                <ins
                  style={{ color: `${portal.data.settings.colours.primary}` }}
                >
                  4
                </ins>
              </span>
            </Link>
          ) : currentPage === "step-3" ? (
            <Link
              to={`/step-3`}
              style={{ borderColor: `${portal.data.settings.colours.primary}` }}
            >
              <span>
                <i class="fa fa-check"></i>
                <ins
                  style={{ color: `${portal.data.settings.colours.primary}` }}
                >
                  4
                </ins>
              </span>
            </Link>
          ) : currentPage === "step-3-manual" ? (
            <Link
              to={`/step-3-manual`}
              style={{ borderColor: `${portal.data.settings.colours.primary}` }}
            >
              <span>
                <i class="fa fa-check"></i>
                <ins
                  style={{ color: `${portal.data.settings.colours.primary}` }}
                >
                  4
                </ins>
              </span>
            </Link>
          ) : (
            <Link
              to={`/step-4`}
              style={{
                backgroundColor: `${portal.data.settings.colours.primary}`,
              }}
            >
              <span>
                <i class="fa fa-check"></i>
                <ins style={{ color: "white" }}>4</ins>
              </span>
            </Link>
          )}
        </div>
      </div>
    </>
  );
}
